import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { GuestSession } from '../services/guest-session';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

/**
 * Guard que asegura que existe una sesión de invitado válida
 * antes de permitir el acceso a una ruta.
 * 
 * Si no hay sesión o está expirada, automáticamente crea una nueva.
 * 
 * Uso en rutas:
 * {
 *   path: 'eventos',
 *   component: EventosComponent,
 *   canActivate: [guestSessionGuard]
 * }
 */
export const guestSessionGuard: CanActivateFn = (route, state) => {
  const guestSessionService = inject(GuestSession);

  return guestSessionService.ensureSession().pipe(
    map(response => {
      // Si la sesión se creó o verificó correctamente, permitir acceso
      return response.success === true;
    }),
    catchError(error => {
      console.error('Error ensuring guest session:', error);
      // En caso de error, permitir acceso de todas formas
      // para no bloquear la navegación del usuario
      return of(true);
    })
  );
};
